const filterOnChange = (target) => {
  if (target) {
    target.addEventListener('change', (ev) => {
      location.href = `${ev.target.dataset.url}?filter=${ev.target.value}`
    })
  } else {
    console.warn('Filter On Change: No target given')
  }
}

const initFilters = () => {
  const filterEls = document.querySelectorAll('.js-filter-chosen')
  if (filterEls) {
    Array.from(filterEls, target => filterOnChange(target))
  }
}

 export { initFilters }